<template>
  <div class="snowie__page">
    <Nav />
    <Hello />
    <Intro />
    <About />
    <Skills />
    <Work />
    <Contact />
  </div>
</template>

<script>
import Nav from "../componentsv2/Nav";
import Hello from "../componentsv2/Hello";
import Intro from "../componentsv2/Intro";
import About from "../componentsv2/About";
import Skills from "../componentsv2/Skills";
import Work from "../componentsv2/Work";
import Contact from "../componentsv2/Contact";

export default {
  name: "Indexv2",
  components: {
    Nav,
    Hello,
    Intro,
    About,
    Skills,
    Work,
    Contact
  }
};
</script>

<style lang="scss"></style>
